import {
  Component, computed, CUSTOM_ELEMENTS_SCHEMA, ElementRef, inject, OnInit, viewChild
} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {GameStore} from '../../store/game.store';
import {ResourcesService} from '../../services/resources.service';
import {ScoreBarComponent} from '../../components/score-bar/score-bar.component';
import {QuestionAnswerCardComponent} from '../../components/question-answer-card/question-answer-card.component';
import {ShareScoreComponent} from '../../components/share-score/share-score.component';
import {ScoreClassification} from '../../store/features/with-score.feature';

@Component({
  selector: 'gis-game-over-screen',
  imports: [
    ButtonModule,
    ScoreBarComponent,
    QuestionAnswerCardComponent,
    ShareScoreComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './game-over-screen.component.html',
  styleUrl: './game-over-screen.component.scss'
})
export class GameOverScreenComponent implements OnInit {
  protected readonly store = inject(GameStore);
  protected readonly resourcesService = inject(ResourcesService);

  readonly scoreHeader = viewChild<ElementRef<HTMLElement>>('scoreHeader');

  showScore = false;

  protected readonly accessibleScoreStatus = computed(() => {
    const template = this.resourcesService.languageFile.value().scoreStatus;
    return template
      .replace('%%', this.store.score().toString())
      .replace('%%', this.store.maxScore().toString());
  });

  get scoreIconSource(): string {
    switch (this.store.scoreClassification()) {
      case ScoreClassification.Max:
      case ScoreClassification.High:
        return 'assets/icons/high-score-trophy.svg';
      case ScoreClassification.Medium:
        return 'assets/icons/medium-score-ribbon.svg';
      case ScoreClassification.Low:
        return 'assets/icons/low-score-medal.svg';
      default:
        return '';
    }
  }

  ngOnInit() {
    setTimeout(() => {
      this.showScore = true;
      this.scoreHeader()?.nativeElement.focus();
    });
  }
}
